import styled from "styled-components";

export const CardLi = styled.li`
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  background: white;
  border-radius: 4px;
  padding: 10px 12px 10px 6px;
  gap: 7px;
  min-height: 120px;
  transition: all 0.15s;
  margin: 8px 0;
  position: relative;
  overflow: hidden;

  :hover {
    box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.15);
  }

  .basel {
    min-height: 50px;
    border-radius: 3px;
    width: 5px;
    flex-shrink: 0;
  }

  .li_content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    padding-right: 4px;
  }

  .card-delete {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
    border: none;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
    padding: 4px;
    border-radius: 999px;
    line-height: 0;

    :hover {
      background: #f3f4f6;
    }
  }

  .row-split {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
  }

  .row-split > div {
    min-width: 0;
    overflow: hidden;
  }

  .tipo-badge {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .card-id-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
  }

  .axis-badge {
    font-size: 9px;
    letter-spacing: 0.8px;
    font-weight: 600;
    color: #6b7280;
    opacity: 0.65;
    margin-bottom: 2px;
  }

  .card-id {
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    flex-shrink: 0;
  }
`;

export const CardFieldLabel = styled.span`
  display: block;
  font-size: 10px;
  line-height: 1.2;
  color: #6b7280;
`;

export const CardFieldValue = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
